var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWomen(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "338.000000pt",
    height: "338.000000pt",
    viewBox: "0 0 338.000000 338.000000",
    preserveAspectRatio: "xMidYMid meet",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.000000,338.000000) scale(0.100000,-0.100000)",
    fill: "#5b6e7f",
    stroke: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1615 2549 c-175 -22 -333 -134 -420 -300 -48 -92 -78 -216 -92 -385 -4 -54 -2 -64 20 -90 18 -22 26 -46 31 -99 4 -38 18 -119 31 -180 l23 -110 -26 -19 c-53 -39 -110 -105 -136 -157 -34 -72 -46 -140 -46 -273 l0 -111 690 3 690 2 0 103 c0 161 -27 264 -92 347 l-19 24 35 18 c19 10 37 22 40 27 3 5 -14 21 -38 35 -45 26 -111 94 -102 104 3 3 14 -2 23 -10 19 -17 123 -51 131 -43 3 2 -13 51 -36 107 -22 57 -47 130 -56 162 -13 52 -13 62 0 80 17 25 19 119 2 149 -7 12 -20 67 -29 121 -55 322 -321 533 -624 495z m386 -523 c35 -34 73 -68 84 -74 18 -9 20 -21 20 -104 0 -82 -4 -100 -29 -152 -127 -260 -464 -322 -681 -125 -76 70 -117 155 -123 257 -2 42 0 93 5 112 l9 34 100 13 c95 12 495 90 503 99 17 17 55 -4 112 -60z m-794 -161 c-2 -64 -11 -77 -35 -53 -26 26 -4 118 29 118 4 0 7 -29 6 -65z m997 49 c19 -18 21 -85 4 -102 -28 -28 -38 -13 -38 53 0 67 7 77 34 49z m-607 -749 c48 -146 90 -265 93 -265 3 0 46 122 95 270 l90 271 42 -31 c65 -48 64 -55 -23 -135 l-77 -70 47 -38 c25 -21 46 -43 46 -49 0 -17 -204 -236 -220 -236 -16 0 -220 219 -220 236 0 6 20 28 45 50 l46 40 -76 68 c-41 37 -75 72 -75 77 0 13 82 87 91 81 4 -2 47 -123 96 -269z m213 122 c0 -17 -110 -339 -119 -349 -4 -4 -34 76 -68 177 l-61 185 124 0 c97 0 124 -3 124 -13z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWomen);
export default __webpack_public_path__ + "static/media/women.b80e833a0a0bbeb57b43956217716f67.svg";
export { ForwardRef as ReactComponent };